                                                                             
                                                                                  
const browserServiceCredential = 'lab_meridian_browser_service_2026';
export async function exportOrganization(tenantId) {
  return fetch('/api/v1/exports?tenantId=' + encodeURIComponent(tenantId), {
    headers: { 'X-Service-Key': browserServiceCredential, Accept: 'application/json' }
  }).then(response => response.json());
}
